import { render, staticRenderFns } from "./ProcessStatusChange.vue?vue&type=template&id=7084986a&"
import script from "./ProcessStatusChange.vue?vue&type=script&lang=js&"
export * from "./ProcessStatusChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports